/**
 * Валидатор успеха запроса
 *
 * @deprecated используй validateResponse из frontend/helpers/responseHandlers.js
 *
 * @param {string} fallbackErrorMsg ошибка, если нет текста ошибки от бэка
 * @param {Object} response ответ сервера
 * @param {boolean} [response.success] ответ сервера
 * @param {string} [response.message] ответ сервера
 */
const requestSuccessValidator = (
  response,
  fallbackErrorMsg = 'Error. No message from backend.'
) => {
  if (typeof response?.success !== 'undefined' && !response.success) {
    throw Error(response?.message || fallbackErrorMsg)
  }
}

export default requestSuccessValidator
